import script from "./sdg-impact-by-sdg.vue?vue&type=script&lang=ts&setup=true"
export * from "./sdg-impact-by-sdg.vue?vue&type=script&lang=ts&setup=true"

import "./sdg-impact-by-sdg.vue?vue&type=style&index=0&id=790cb518&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790cb518"]])

export default __exports__